"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ThreadIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.037.982A.75.75 0 01.751 0H11.44c.51 0 .87.497.713.982l-.575 1.767a.75.75 0 01-.713.518h-9.54a.75.75 0 01-.713-.518L.037.982zm0 12.036A.75.75 0 00.751 14H11.44a.75.75 0 00.713-.982l-.575-1.767a.75.75 0 00-.713-.518h-9.54a.75.75 0 00-.713.518l-.575 1.767zm.85-7.638c0-.486.366-.88.819-.88h8.744c.453 0 .82.394.82.88s-.367.88-.82.88H1.706c-.453 0-.82-.394-.82-.88zm.819 2.299c-.453 0-.82.394-.82.88 0 .487.367.88.82.88h8.653c.03.004.06.006.091.006.247 0 .775.027 1.216.255.208.108.373.248.487.43.112.177.224.557.224.99 0 .486.367.88.82.88.453 0 .82-.394.82-.88 0-.741-.19-1.473-.505-1.975a2.89 2.89 0 00-1.135-1.031c-.714-.37-1.47-.422-1.828-.429a.771.771 0 00-.099-.006H1.706z",
    clipRule: "evenodd"
  })))
});
ThreadIcon.displayName = 'ThreadIcon';
var _default = exports.default = ThreadIcon;